import { render, staticRenderFns } from "./ServicesByDistrict.vue?vue&type=template&id=28209c8a&scoped=true&"
import script from "./ServicesByDistrict.vue?vue&type=script&lang=js&"
export * from "./ServicesByDistrict.vue?vue&type=script&lang=js&"
import style0 from "./ServicesByDistrict.vue?vue&type=style&index=0&id=28209c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28209c8a",
  null
  
)

export default component.exports